<ng-container *ngIf="this.showCmsNews">
  <div class="c-news container-lg">
    <div class="c-news__list" *ngIf="this.cmsNews?.length > 0">

      <!-- <div class="c-news__latest-news">
        <div class="c-news__card" *ngFor="let news of this.cmsNews; let i = index" (click)="goToNews(news)"
          [ngClass]="{'c-news__card--big': i == 0, 'c-news__card--medium': i > 0}">
          <ng-container *ngTemplateOutlet="newsPreview; context: {news: news}"></ng-container>
        </div>
      </div>

      <div *ngIf="this.cmsNews.length > 3" class="all-news-title e-title e-title__with-divider">
        <h2 class="h2">Tutte le news</h2>
        <hr class="hr hr--heavy hr--brand hr--title mb-2">
      </div> -->

      <div class="c-news__all-news">
        <div class="c-news__card c-news__card--small" *ngFor="let news of this.cmsNews" (click)="goToPage(news)">
          <ng-container *ngTemplateOutlet="newsPreview; context: {news: news}"></ng-container>
        </div>
      </div>


    </div>
  </div>

</ng-container>

<ng-container *ngIf="!this.showCmsNews">
  <div class="page">
    <div class="container-fluid p-0">
      <div class="breadcrumb-generic breadcrumb-generic--overlay"
        style="background-image: url('./assets/images/bg_contact-us.jpg');">
        <div class="container-sm">
          <h1 class="breadcrumb-generic__title">News</h1>
        </div>
      </div>
    </div>
    <div class="page-content news-card">
      <div class="container">
        <div class="e-title e-title__with-divider">
          <h2 class="h2">Tutte le news</h2>
          <hr class="hr hr--heavy hr--brand hr--title mb-2">
          <!--      <p>In hac habitasse platea dictumst. Vivamus adipiscing fermentum quam volutpat aliquam. Integer et elit eget elit facilisis tristique. Nam vel iaculis mauris. Sed ullamcorper tellus erat, non ultrices sem tincidunt euismod. Fusce rhoncus porttitor velit, eu bibendum nibh aliquet vel. Fusce lorem leo, vehicula at nibh quis,.</p>-->
        </div>
        <div class="row">
          <div class="col-12 col-md-6"
            *ngFor="let item of legacyNews$ | async | filterBy: ['visible']: [true] | orderBy: '-date'">
            <a class="card news-card__item" [routerLink]="item.searchId">
              <div class="row">
                <div class="col-md-4">
                  <img [src]="item.image" class="card-img news-card__img" [alt]="item.title">
                </div>
                <div class="col-md-8">
                  <div class="card-body news-card__body">
                    <h5 class="card-title news-card__title">{{item.title}}</h5>
                    <p class="card-text news-card__text">{{item.subtitle}}</p>
                    <p class="card-text news-card__text"><small class="text-muted">Pubblicata il
                        {{item.date | dayjs: 'DD MMMM YYYY'}}</small></p>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #newsPreview let-news="news">
  <div class="c-news__card-image" [ngStyle]="{'background-image': 'url(' + news.image + ')'}"></div>
  <div class="c-news__card-content">
    <h3 class="c-news__title u-ellipsis--lin-3">{{news.title}}</h3>
  </div>
  <div class="c-news__card-footer">
    <!-- <small>Pubblicata il <span class="date">{{news.createdAt | dayjs: 'DD MMMM YYYY'}}</span></small> -->
    <button class="c-news__cta btn btn--brand-color-03">Leggi</button>
  </div>
</ng-template>
